/**
 * Extracts plain text from an HTML string.
 *
 * Uses `DOMParser` to parse the markup in an isolated, detached document
 * (never attached to the live DOM) so there is no XSS surface — parsed
 * content is never inserted into the page, only its `textContent` is read.
 */
export function stripHtmlToText(html: string): string {
  if (!html) {
    return '';
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const text = doc.body.textContent ?? '';

  return text.replace(/\s+/g, ' ').trim();
}

/**
 * Normalizes a string for case- and diacritic-insensitive search matching:
 * lowercases, then strips combining diacritical marks via NFD decomposition.
 *
 * Deliberately avoids the `\p{Diacritic}` unicode property escape — this
 * repo's tsconfig target is `es5`, which doesn't support the `u` regex flag
 * required for unicode property escapes.
 */
export function normalizeForSearch(s: string): string {
  if (!s) {
    return '';
  }

  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}
